import axios from 'axios';
import qs from 'qs';
import Session from './Session';
import Global from './Global';

import {
  Indicator,
  Toast
} from 'mint-ui';


const Axios = axios.create({
  baseURL: process.env.BASE_API_DOMAIN,
  timeout: 10000,
  responseType: 'json',
  retry: 2,
  retryDelay: 100,
  withCredentials: false // 是否允许带cookie(跨域请求时是否需要使用凭证)
})

let loading = false;
// 请求发送拦截
Axios.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    if (config.data.showLoading != false) { loading = true; Indicator.open(); }
    config.data = qs.stringify(config.data)
  } else {
    if (config.params.showLoading != false) { loading = true; Indicator.open(); }
  }
  if (Session.authorization) {
    config.headers.Authorization = Session.authorization;
  }
  return config;
}, function (error) {
  try {
    if (loading === true) { loading = false; Indicator.close(); }
  } catch (e) { }
  return Promise.reject(error);
});

// 请求响应拦截
Axios.interceptors.response.use(res => {
  try {
    if (loading === true) { loading = false; Indicator.close(); }
  } catch (e) { }
  if (res.data.code && res.data.code != 0 && res.data.msg && res.data.msg != "") {
    Toast(res.data.msg);
  }
  return Promise.resolve(res.data)
}, error => {
  try {
    if (loading === true) { loading = false; Indicator.close(); }
  } catch (e) { }
  if (error.response.status == 404) {
    Toast("请求地址错误");
  } else if (error.response.status == 500) {
    Toast("系统内部错误");
  } else if (error.response.status == 401) {
    var operId = decodeURIComponent((new RegExp('[?|&]operId=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    window.location = Global.baseApiDomain + "/wechat/forward?operId=" + (operId == null ? "" : operId) + "&redirectUrl=" + encodeURIComponent(window.location.href);
  } else {
    Toast("错误：【" + error.response.status + "】" + error.response.data.message);
  }
  return Promise.reject(error);
});
export default Axios



// WEBPACK FOOTER //
// ./src/utils/Axios.js